import { defineComponent } from "vue";

export default defineComponent({
  template: `
    <div>
    <div class="tariff-card-slider">
    <slot></slot>
    </div>
    <p class="text-center text-muted mt-3" v-if="this.showCarrierInfo">
    PODA využívá mobilní síť T-Mobile, která se vyznačuje
    širokým pokrytím, rychlostí a spolehlivostí.
    </p>
    </div>
  `,
  name: "TariffCardSlider.vue",
  props: {
    isClient: {
      type: Boolean,
      required: true,
    },
    showCarrierInfo: {
      type: Boolean,
      default: true,
      required: false,
    },
  },
});
